/*eslint camelcase:0 */
import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import Grid from '@bingads-webui-component-legacy/grid/index';
import tmpl from '@bingads-webui-campaign-legacy/crud-adgroup/template/keywordPlanner.pug';
import keywordPlannerAdgroupNameColumnTemplate from '@bingads-webui-campaign-legacy/crud-adgroup/template/keywordPlannerAdgroupNameColumnTemplate.pug';
import keywordPlannerAdgroupSeeMoreColumnTemplate from '@bingads-webui-campaign-legacy/crud-adgroup/template/keywordPlannerAdgroupSeeMoreColumnTemplate.pug';
import SourceProjection from '@bingads-webui-component-legacy/grid/projection/sink';
import PropertyTemplateProjection from '@bingads-webui-component-legacy/grid/projection/property-template';
import MemorySortProjection from '@bingads-webui-component-legacy/grid/projection/memory-sort';
import MemoryPageProjection from '@bingads-webui-component-legacy/grid/projection/memory-page';
import MapProjection from '@bingads-webui-component-legacy/grid/projection/map';
import PageProjection from '@bingads-webui-component-legacy/grid/projection/page';
import TableLayout from '@bingads-webui-component-legacy/grid/layout/table';
import tableTmplJade from '@bingads-webui-component-legacy/grid/layout/template/table.alt.pug';
import Pagination from '@bingads-webui-component-legacy/pagination/index';
import PaginationTmpl from '@bingads-webui-component-legacy/pagination/layout/simple.pug';
import Searchbox from '@bingads-webui-component-legacy/searchbox/view/searchbox';
import ViewModel from '@bingads-webui-campaign-legacy/crud-adgroup/viewmodel/keywordPlanner';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import KeywordPlannerAdvancedView from '@bingads-webui-campaign-legacy/crud-adgroup/view/keywordPlannerAdvanced';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import * as keywordPlannerCreateOptions from '@bingads-webui-campaign-legacy/crud-adgroup/viewmodel/keywordPlannerCreateOptions';
import decimalFormatter from '@bingads-webui-component-legacy/humanize/decimal';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import PaginationConnector from '@bingads-webui-component-legacy/connectors/grid.pagination';
import { keywordPlannerSortFunc } from '@bingads-webui-campaign-legacy/crud-adgroup/keywordPlannerSort';
import * as locationFilters from '@bingads-webui-campaign-legacy/location-targets/util/filters';
import { keywordPlannerSupportedCountries, keywordPlannerSupportedLanguages, isSelectedLanguagesOnlyTire2ForKeywordPlanner, getKeywordPlannerSupportedLanguagesByLocationIds, getKeywordPlannerSupportedLocationIdsByLangauges } from '@bingads-webui-campaign-legacy/location-targets/util/constants';
import * as languageBundle from '@bingads-webui-campaign-legacy/location-targets/util/languageBundle';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import learnMoreTemplate from '@bingads-webui-campaign-legacy/crud-adgroup/template/learn-more.pug';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import { getSearchRangeString } from '../share/getSearchRange';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const languagesAllNumber = 1000;
const popupIds = {
  GetKeywordIdeas: 'pop_BA_CampaignCreate_Keywords_GetKeywordIdeas',
  MonthlySearches: 'pop_BA_CampaignCreate_Keywords_MonthlySearches',
  AvgCPC: 'pop_BA_CampaignCreate_Keywords_AvgCPC',
  Competition: 'pop_BA_CampaignCreate_Keywords_Competition',
  GetAdGroupIdeas: 'pop_BA_CampaignCreate_Keywords_GetAdGroupIdeas',
};
const keywordLikePrefix = 'Keyword Like: ';

export default class View extends Backbone.View {
  get events() {
    return {
      'click .keyword-planner-search-button': this.onSearch.bind(this),
      'click a.select-all-on-page': 'addKeywordsInPage',
    };
  }

  initialize(options = {}) {
    this.options = options;
    this.currentSourceReqId = '';
    this.popupIds = _.defaults({}, this.options.popupIds, popupIds);
    this.viewmodel = new ViewModel();
    this.pageSize = this.options.mode === 'keywordsOnly' ? 9 : 5;
    this.usePanel = options && options.usePanel;

    this.searchboxKeywords = new Searchbox({ defaultText: i18n.get('KeywordPlanner_SearchPlaceholderKeywords'), searchButtonAriaLabel: i18n.get('KeywordPlanner_SearchKeywordsButton') });
    this.searchboxKeywords.on('search', (value) => {
      this.onSearch({ keywords: value });
    });

    this.searchboxUrl = new Searchbox({ defaultText: i18n.get('KeywordPlanner_SearchPlaceholderUrl'), searchButtonAriaLabel: i18n.get('KeywordPlanner_SearchWebsiteURLButton') });
    this.searchboxUrl.on('search', (value) => {
      this.onSearch({ url: value });
    });

    if (this.usePanel) {
      this.AdvancedView = panelDecorator(KeywordPlannerAdvancedView, {
        i18n,
        panelReadyAriaLabel: i18n.getString('Keyword planner side panel opened'),
      });
    } else {
      this.AdvancedView = dialogDecorator.decorate(KeywordPlannerAdvancedView, { position: 'center', maxWidth: 2000, popupFront: '.navbar-fixed-top' });
    }
  }

  static get odataLimits() {
    return {
      url: 2000,
      location: 100,
      keywordLength: 100,
    };
  }

  static get keywordPlannerSupportedLanguagesIdValueMap() {
    return _.invert(keywordPlannerSupportedLanguages);
  }

  static isLanguageSupported(language) {
    const languagesToCheck = _.isArray(language) ? language : [language];

    if (_.contains(languagesToCheck, 'All') || _.contains(languagesToCheck, languagesAllNumber)) {
      return true;
    }

    return _.any(languagesToCheck, (lang) => {
      if (_.isNumber(lang)) {
        return _.contains(_.values(keywordPlannerSupportedLanguages), lang);
      }

      return _.contains(_.keys(keywordPlannerSupportedLanguages), lang);
    });
  }

  /* input: languages, an array of language selected by user
     only accept strings here
     it will remove the unsupported language, only set the supported ones to viewmodel (used in parameter)
  */
  setLanguages(languages) {
    this.originalLanguages = languages; // for AdInsight log
    if (_.contains(languages, 'All') || _.contains(languages, languagesAllNumber)) {
      this.viewmodel.languages(_.keys(keywordPlannerSupportedLanguages));
    } else {
      // convert numbers to string
      const languages2Use = _.chain(languages)
        .map((lang) => {
          if (_.isNumber(lang)) {
            return View.keywordPlannerSupportedLanguagesIdValueMap[lang]; // undefined if not supported
          } else {
            return lang;
          }
        }).compact().value();

      this.viewmodel.languages(_.intersection(languages2Use, _.keys(keywordPlannerSupportedLanguages)));
    }
  }

  getLanguagesSupportedByLocations(useTireTwoMarkets = false) {
    const locationSupportedLanguages =
      getKeywordPlannerSupportedLanguagesByLocationIds(this.viewmodel.locations(), useTireTwoMarkets);

    return _.intersection(this.viewmodel.languages(), locationSupportedLanguages);
  }

  onlyTire2LangaugesSelected(crossCheckWithTargets = false) {
    const languagesCanUse = crossCheckWithTargets ?
      this.getLanguagesSupportedByLocations(true) :
      this.viewmodel.languages();

    return !_.isEmpty(languagesCanUse) && isSelectedLanguagesOnlyTire2ForKeywordPlanner(languagesCanUse);
  }

  /* input: targets, an array of RadiusCriterion and LocationCriterion objects.
     output: an array of the LocationIds that are within the supported countries & will be used for targeting
  */
  setLocationTargeting(includedTargets) {
    this.viewmodel.locations([]);
    this.viewmodel.numLocationsTargeted(0);
    this.viewmodel.countryLocationInfo([]);

    if (_.isArray(includedTargets) && !_.isEmpty(includedTargets)) {
      let locationTargets = _.filter(includedTargets, (criterion) => {
        return criterion.Type === 'Location' || criterion.Type === 'Radius';
      });
      const supportedCountries = _.values(keywordPlannerSupportedCountries);
      const supportedCountryCodes = _.pluck(supportedCountries, 'Code');
      const supportedTire2CountryCodes = _.pluck(_.select(supportedCountries,
        (country) => {
          return !country.SupportKeywordSearch;
        }), 'Code');
      const countryLocationInfo = [];

      _.each(locationTargets, (target) => {
        if (target.Type === 'Location') {
          const countryCode = target.CountryCode;

          if (_.contains(supportedCountryCodes, countryCode)) {
            const locationId = target.LocationType === 'PostalCode' ?
              languageBundle.getPublisherCountryByCode(countryCode).LocationId :
              target.LocationId;

            if (!_.contains(this.viewmodel.locations(), locationId)) {
              this.viewmodel.locations.push(locationId);
              countryLocationInfo.push({
                locationId,
                countryLocationId: languageBundle.getPublisherCountryByCode(countryCode).LocationId,
              });
            }

            if (_.contains(supportedTire2CountryCodes, countryCode) &&
              !_.contains(this.viewmodel.tire2Locations(), locationId)) {
              this.viewmodel.tire2Locations.push(locationId);
            }
          }
        }
      });

      this.viewmodel.countryLocationInfo(countryLocationInfo);
      this.viewmodel.numLocationsTargeted(_.size(includedTargets));
    } else if (this.onlyTire2LangaugesSelected()) {
      const tire2SupportedCountryIds = getKeywordPlannerSupportedLocationIdsByLangauges(this.viewmodel.languages());

      this.viewmodel.tire2Locations(tire2SupportedCountryIds);
      this.viewmodel.locations(tire2SupportedCountryIds);
      this.viewmodel.numLocationsTargeted(_.size(tire2SupportedCountryIds));
      const countryLocationInfo = [];

      _.each(tire2SupportedCountryIds, (Id) => {
        countryLocationInfo.push({
          locationId: Id,
          countryLocationId: Id,
        });
      });
      this.viewmodel.countryLocationInfo(countryLocationInfo);
    } else {
      const supportedCountryIds = getKeywordPlannerSupportedLocationIdsByLangauges(this.viewmodel.languages());
      const countryLocationInfo = [];

      this.viewmodel.locations(supportedCountryIds);
      this.viewmodel.numLocationsTargeted(_.size(supportedCountryIds));
      _.each(supportedCountryIds, (Id) => {
        countryLocationInfo.push({
          locationId: Id,
          countryLocationId: Id,
        });
      });
      this.viewmodel.countryLocationInfo(countryLocationInfo);
    }

    this._updateStatusByLocations();

    return this.viewmodel.locations();
  }

  setLocationTargetingByCampaign() {
    const locationsObj = locationFilters.getSupportedLocationIds(jsdata.Intermediate.getAll('CampaignCriterion'), true);

    this.viewmodel.locations(locationsObj.items);
    this.viewmodel.numLocationsTargeted(locationsObj.totalCount);
    this.viewmodel.countryLocationInfo(locationsObj.countryLocationInfo);

    this._updateStatusByLocations();
  }

  _updateStatusByLocations() {
    // if no tire-1 langauge supported, then see tire 2
    if (this.viewmodel.allLocationsUnsupported()) {
      this.searchboxUrl.disable();
      this.searchboxKeywords.disable();
    } else if (this.onlyTire2LangaugesSelected(true)) {
      this.searchboxUrl.enable();
      this.searchboxKeywords.disable();
    } else {
      // if any of tire 1 language/location supported, show both
      this.searchboxUrl.enable();
      this.searchboxKeywords.enable();
    }
  }

  _updateSelectMultiIdeasText() {
    this.viewmodel.selectMultiIdeasText(i18n.get('KeywordPlanner_Select_All_In_Page', {
      count: Math.min(this.viewmodel.gridData().length - (this.paginationView.ko_model.page_number() * this.paginationView.ko_model.page_size()), this.paginationView.ko_model.page_size()),
    }));
  }

  updatePagination(resetPageNumber) {
    if (!_.isUndefined(resetPageNumber)) {
      this.paginationView.ko_model.page_number(0);
    }
    this.paginationView.ko_model.item_count(this.viewmodel.gridData().length);

    const pageCount = Math.ceil(this.viewmodel.gridData().length / this.paginationView.ko_model.page_size());

    if (pageCount > 0 && pageCount <= this.paginationView.ko_model.page_number()) {
      this.grid.projection.set('page.number', pageCount - 1);
      this.paginationView.ko_model.page_number(pageCount - 1);
    }

    this._updateSelectMultiIdeasText();
  }

  get uri() {
    return 'Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.AdGroupSuggestions?$expand=Suggestions';
  }

  requestData(value) {
    let req = {
      'criteria': [],
    };

    let hasOnlyKeyword = true;

    if (value.url) {
      hasOnlyKeyword = false;
      // KeywordPlanner has a url length limit
      // This url is solely for keyword suggestion purpose and
      // not saved or used by other feature
      let requestUrl = value.url.substr(0, View.odataLimits.url);

      req.criteria.push({
        '@odata.type': '#Model.Suggestions.UrlSuggestionCriterion',
        'Url': requestUrl,
      });
    }

    if (value.keywords) {
      let keywordsArray = _.isArray(value.keywords) ? value.keywords : [value.keywords];

      _.each(keywordsArray, (keyword) => {
        req.criteria.push({
          '@odata.type': '#Model.Suggestions.SeedKeywordSuggestionCriterion',
          'Keyword': keyword.substr(0, View.odataLimits.keywordLength),
        });
      });
    }

    let languagesToUse = getKeywordPlannerSupportedLanguagesByLocationIds(_.pluck(this.viewmodel.countryLocationInfo(), 'countryLocationId'), !hasOnlyKeyword);
    // add parameter when keyword planner support more than one language in multi-language pilot

    if (!_.isEmpty(this.viewmodel.languages())) {

      // keyword only mode only support one langue for now, will update this after they fix the bug
      if (hasOnlyKeyword && languagesToUse.length > 1) {
        languagesToUse = [_.first(languagesToUse)];
      } else if (!hasOnlyKeyword && languagesToUse.length > 3) {
        // url only support 3 for now, will udpate this after they fix the bug
        languagesToUse = _.first(languagesToUse, 3);
      }
      _.each(languagesToUse, (language) => {
        if (language) {
          req.criteria.push({
            '@odata.type': '#Model.Suggestions.LanguageSuggestionCriterion',
            'Language': language,
          });
        }
      });
    }

    if (_.isArray(this.viewmodel.locations())) {
      // KeywordPlanner OData has a location count limit
      const languageSupportedLoations = _.isEmpty(languagesToUse) ?
        this.viewmodel.locations() :
        getKeywordPlannerSupportedLocationIdsByLangauges(languagesToUse, !hasOnlyKeyword);

      const locationIdsSupportedByLanguage = _.compact(_.map(this.viewmodel.countryLocationInfo(), (item) => {
        if (_.contains(languageSupportedLoations, item.countryLocationId)) {
          return item.locationId;
        }
        return 0;
      }));

      let requestLocations = _.first(
        locationIdsSupportedByLanguage,
        View.odataLimits.location);

      _.each(requestLocations, (locationId) => {
        if (locationId) {
          req.criteria.push({
            '@odata.type': '#Model.Suggestions.LocationSuggestionCriterion',
            'LocationId': locationId,
          });
        }
      });
    }


    return req;
  }

  getPropTempl() {
    if (this.options.mode === 'keywordsOnly') {
      return new PropertyTemplateProjection({
        'property.template': {
          name(local) {
            if (local.model.$metadata.type === 'keyword') {
              return keywordPlannerAdgroupNameColumnTemplate({ value: local.model[local.property] });
            }
            return null;
          },
        },
      });
    } else {
      return new PropertyTemplateProjection({
        'property.template': {
          name(local) {
            if (local.model.$metadata.type === 'adgroup') {
              return keywordPlannerAdgroupNameColumnTemplate({ value: local.model[local.property] });
            } if (local.model.$metadata.type === 'see-more') {
              // the template is added for fixing a11y bug.
              return keywordPlannerAdgroupSeeMoreColumnTemplate({ value: local.model[local.property] });
            } else {
              return local.model[local.property];
            }
          },
        },
      });
    }
  }

  getMap() {
    if (this.options.mode === 'keywordsOnly') {
      return new MapProjection({
        map(item) {
          return {
            name: item.Keyword,
            searchCount: getSearchRangeString(item.AggregateMetric.AverageSearchVolume, i18n.realI18n),
            averageCPC: decimalFormatter.fromFloatToString(item.AggregateMetric.AverageCPC, 2),
            competition: i18n.get(`CompetitionLevel_${item.AggregateMetric.CompetitionLevel}`),
            '$metadata': {
              'attr': { 'class': 'table__row--keyword-planner table__row--keywords-only' },
              'type': 'keyword',
            },
          };
        },
      });
    } else {
      return new MapProjection({
        map(item) {
          let ret = [];

          let adgroupItem = {
            name: item.DisplayName,
            searchCount: getSearchRangeString(item.AggregateMetric.AverageSearchVolume, i18n.realI18n),
            averageCPC: decimalFormatter.fromFloatToString(item.AggregateMetric.AverageCPC, 2),
            competition: i18n.get(`CompetitionLevel_${item.AggregateMetric.CompetitionLevel}`),
            '$metadata': {
              'attr': { 'class': 'table__row--keyword-planner table__row--adgroup' },
              'type': 'adgroup',
            },
          };

          ret.push(adgroupItem);

          let numRowsToShow = Math.min(2, item.Suggestions.length);

          for (let i = 0; i < numRowsToShow; i++) {
            let kwd = item.Suggestions[i];

            ret.push({
              name: kwd.Keyword,
              searchCount: getSearchRangeString(kwd.AggregateMetric.AverageSearchVolume, i18n.realI18n),
              averageCPC: decimalFormatter.fromFloatToString(kwd.AggregateMetric.AverageCPC, 2),
              competition: i18n.get(`CompetitionLevel_${kwd.AggregateMetric.CompetitionLevel}`),
              '$metadata': {
                'attr': { 'class': 'table__row--keyword-planner table__row--indent' },
                'type': 'keyword',
                '$parent': adgroupItem,
              },
            });
          }

          if (item.Suggestions.length > 2) {
            ret.push({
              name: i18n.get('KeywordSuggestion_AddMore_Keywords').replace('{0}', item.Suggestions.length - 2),
              searchCount: '',
              averageCPC: '',
              competition: '',
              '$metadata': {
                'attr': {
                  'class': 'table__row--keyword-planner table__row--indent table__row--see-more',
                  'role': 'presentation',
                },
                'type': 'see-more',
                'adgroupName': item.Name,
                '$parent': adgroupItem,
              },
            });
          }

          return ret;
        },
      });
    }
  }

  render() {
    this.$el.html(tmpl({
      i18n,
      title: this.options.isCampaignCreation ? i18n.get('KeywordPlanner_Campaign_Creation_Title') : i18n.get('KeywordPlanner_Title'),
      helpId: this.options.isCampaignCreation ? popupIds.GetAdGroupIdeas : popupIds.GetKeywordIdeas,
      showSelectAllOnPage: !this.options.isCampaignCreation,
    }));

    ko.applyBindings(this.viewmodel, this.el);

    this.searchboxKeywords.render();
    this.$('.searchbox.keywords').append(this.searchboxKeywords.$el);

    this.searchboxUrl.render();
    this.$('.searchbox.url').append(this.searchboxUrl.$el);

    this.paginationView = new Pagination({
      el: this.$('.pagination_host'),
      template: PaginationTmpl,
      page_size: this.pageSize,
    }).render();

    let sourceData = new SourceProjection({ seed: this.viewmodel.gridData() });
    let proptmpl = this.getPropTempl();

    let suggestionPropName = this.options.mode === 'keywordsOnly' ? 'Keyword' : 'Name';

    let sortableCols = {
      searchCount(input, direction) {
        return keywordPlannerSortFunc({ input, direction, prop: 'AverageSearchVolume' });
      },
      averageCPC(input, direction) {
        return keywordPlannerSortFunc({ input, direction, prop: 'AverageCPC' });
      },
      competition(input, direction) {
        return keywordPlannerSortFunc({ input, direction, prop: 'CompetitionLevel' });
      },
      name(input, direction) {
        return keywordPlannerSortFunc({ input, direction, prop: suggestionPropName });
      },
    };

    let memorySort = new MemorySortProjection({
      'column.sortable': sortableCols,
    });

    let memoryPage = new MemoryPageProjection({});
    let map = this.getMap();

    let page = new PageProjection({
      'page.size': this.pageSize,
      'page.number': 0,
    });

    let src = sourceData.pipe(memorySort).pipe(memoryPage).pipe(map).pipe(page).pipe(proptmpl);

    this.grid = new Grid({
      el: this.$('.grid'),
      projection: src,
      layout: TableLayout.partial({
        '$metadata': {
          class: ['table--no-border'],
        },
        template: tableTmplJade,
        columns: {
          'name': {
            '$metadata': {
              'attr.head': { 'width': '34%', 'aria-label': i18n.getString('KeywordPlanner_GridColumn_Suggestions')},
            },
            '$text': i18n.getString('KeywordPlanner_GridColumn_Suggestions'),
            sortable: true,
          },
          'searchCount': {
            '$metadata': {
              'attr.body': { 'class': ['text-right'] },
              'attr.head': { 'class': ['text-right'], 'width': '25%', 'aria-label': i18n.getString('KeywordPlanner_GridColumn_MonthlySearches') },
            },
            '$text': i18n.getString('KeywordPlanner_GridColumn_MonthlySearches'),
            sortable: true,
            popupTopicId: this.popupIds.MonthlySearches,
          },
          'averageCPC': {
            '$metadata': {
              'attr.body': { 'class': ['text-right'] },
              'attr.head': { 'class': ['text-right'], 'aria-label': i18n.getString('KeywordPlanner_GridColumn_AverageCPC') },
            },
            '$text': i18n.getString('KeywordPlanner_GridColumn_AverageCPC'),
            sortable: true,
            popupTopicId: this.popupIds.AvgCPC,
          },
          'competition': {
            '$metadata': {
              'attr.body': { 'class': ['text-right'] },
              'attr.head': { 'class': ['text-right'], 'aria-label': i18n.getString('KeywordPlanner_GridColumn_Competition')/*, 'width': '25%'*/ },
            },
            '$text': i18n.getString('KeywordPlanner_GridColumn_Competition'),
            sortable: true,
            popupTopicId: this.popupIds.Competition,
          },
        },
      }),
    });

    this.grid.on('layout:click:cell', this.gridClicked.bind(this));

    this.grid.render({ fetch: true });

    new PaginationConnector(this.grid, this.paginationView).connect();

    this.paginationView.on('click:next click:previous', this._updateSelectMultiIdeasText.bind(this));

    return this;
  }

  emptySearchTeams() {
    this.searchboxKeywords.ko_model.value('');
    this.searchboxUrl.ko_model.value('');
  }

  onSearch(value) {
    if (this.viewmodel.allLocationsUnsupported()) {
      return;
    }

    if (value && value.keywords) {
      this.searchboxKeywords.ko_model.value(value.keywords);
    }

    if (value && value.url) {
      this.searchboxUrl.ko_model.value(value.url);
    }

    const keywords = this.searchboxKeywords.ko_model.value();
    const url = this.searchboxUrl.ko_model.value();

    if (!keywords && !url) {
      return;
    }

    const requestData = this.requestData({ keywords, url });

    if (_.isEmpty(requestData.criteria)) {
      return;
    }

    odata.post(this.uri, {
      path: 'AdInsight/V2/',
      data: requestData,
      customHeader: {
        name: 'scenario',
        value: this.options.scenario,
      },
    }, (dummy, response, textStatus, xhr)  => {
      this.currentSourceReqId = (xhr && xhr.getResponseHeader('x-ms-requestid')) || '';
    })
      .then((res) => {
        if (this.options.mode === 'keywordsOnly') {
          let data = _.pluck(res.value, 'Suggestions');

          data = _.union.apply(this, data);
          this.viewmodel.gridData(data);
          this.showNoSuggestionsMessage(data);
        } else {
          // update ad group name as required
          _.each(res.value, (item) => {
            item.AdgroupName = item.Name.replace(keywordLikePrefix, '');
            item.DisplayName = `${item.AdgroupName} ${i18n.get('KeywordPlanner_AdGroupSuffix')}`;
          });
          this.viewmodel.gridData(res.value);
          this.showNoSuggestionsMessage(res.value);
        }

        this.grid.projection.set({
          'orderby': [{ 'searchCount': -1 }],
          'page.number': 0,
        });

        this.updatePagination(true);
        this.refreshGridSource(this.viewmodel.gridData());

        // Language log for AdInsight
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'keywordplanner/selectedlanaguage', {
          requestId: this.currentSourceReqId,
          userSelectedLanguages: this.originalLanguages,
        });
      })
      .finally(withUiBlock(this.$el.parent()));
  }

  showNoSuggestionsMessage(suggestions) {
    if (suggestions.length === 0) {
      this.viewmodel.noSuggestionNote(i18n.get('KeywordPlanner_NoSuggestionsReturned_Note_Html', {
        learnMoreLink: learnMoreTemplate({
          i18n,
          helpId: '56794',
        }),
      }));
    } else {
      this.viewmodel.noSuggestionNote(false);
    }
  }

  refreshGridSource(source) {
    this.grid.projection.set({
      'seed': source,
    });
  }

  onClose() {
    if (this.editor) {
      this.editor.remove();
      delete this.editor;
    }
  }

  logInteraction(message) {
    if (this.options.activityLogger) {
      this.options.activityLogger.signal(message, 'keyword planner');
    }
  }

  addAddGroup(args) {
    this.trigger('addAdgroup', args);
    this.logInteraction('add ad group');
  }

  handleAddGroup(args) {
    this.editor.remove();
    this.addAddGroup(args);
    this.removeAdgroupFromSource(args.data.Name);
  }

  gridClicked(e, data) {
    let name = data.model.name.valueOf();

    if (_.isUndefined(data.model.$metadata)) {
      return;
    }

    if (data.model.$metadata.type === 'see-more' && data.column.property === 'name') {
      let adgroupName = data.model.$metadata.adgroupName;
      let adgroups = this.viewmodel.gridData();
      let adgroup = _.find(adgroups, (ag) => {
        return ag.Name === adgroupName;
      });

      if (this.usePanel) {
        this.editor = new this.AdvancedView({
          SuggestedAdGroup: adgroup,
          AdGroups: this.viewmodel.adgroups,
          sourceReqId: this.currentSourceReqId,
          title: `${i18n.get('KeywordPlanner_AdvancedPopup_Title')} ${adgroup.AdgroupName}`,
          eventsToActions: [{
            event: 'cancel',
            action: this.onClose.bind(this),
          }, {
            event: 'addAdgroup',
            action: (args) => this.handleAddGroup(args),
          }],
          onClose: this.onClose.bind(this),
        }).render();
      } else {
        this.editor = new this.AdvancedView({
          SuggestedAdGroup: adgroup,
          AdGroups: this.viewmodel.adgroups,
          sourceReqId: this.currentSourceReqId,
          title: `${i18n.get('KeywordPlanner_AdvancedPopup_Title')} ${adgroup.AdgroupName}`,
        }).render();
        this.editor.on('addAdgroup', (args) => this.handleAddGroup(args));
        this.editor.on('cancel', this.onClose.bind(this));
      }
    } else if (data.model.$metadata.type === 'adgroup') {
      let adgroup = _.find(this.viewmodel.gridData(), (ag) => {
        return ag.DisplayName === name;
      });

      this.addAddGroup({
        sourceReqId: this.currentSourceReqId, // for AdInsight log purpose
        data: _.extend({}, adgroup, { Name: adgroup.AdgroupName }),
        mode: keywordPlannerCreateOptions.AddToNewAdGroup,
      });
      this.viewmodel.recentUserActionPrompt(i18n.get('KeywordPlanner_LiveRegion_Text', { name }));
      this.removeAdgroupFromSource(adgroup.Name);
    } else if (this.options.mode === 'keywordsOnly' && data.model.$metadata.type === 'keyword') {
      this.trigger(
        'addKeyword',
        name,
        this.currentSourceReqId, // for AdInsight log purpose
      );
      this.logInteraction('add a keyword');

      this.viewmodel.gridData(_.filter(this.viewmodel.gridData(), (kw) => {
        return kw.Keyword !== name;
      }));
      this.viewmodel.recentUserActionPrompt(i18n.get('KeywordPlanner_LiveRegion_Text', { name }));
      this.updatePagination();
      this.refreshGridSource(this.viewmodel.gridData());
    }
  }

  addKeywordsInPage() {
    const data = this.viewmodel.gridData();
    const start = this.paginationView.ko_model.page_number() * this.paginationView.ko_model.page_size();
    const end = start + this.paginationView.ko_model.page_size();
    const newData = data.slice(0, start).concat(data.slice(end));

    _.each(data.slice(start, end), (kw) => this.trigger('addKeyword', kw.Keyword, this.currentSourceReqId));

    this.logInteraction('add keywords in page');

    this.viewmodel.gridData(newData);
    this.updatePagination();
    this.refreshGridSource(this.viewmodel.gridData());
  }

  removeAdgroupFromSource(adgroupName) {
    this.viewmodel.gridData(_.filter(this.viewmodel.gridData(), (ag) => {
      return ag.Name !== adgroupName;
    }));
    this.updatePagination();
    this.refreshGridSource(this.viewmodel.gridData());
  }

  updateAdgroupsList(adgroupArray) {
    this.viewmodel.adgroups = adgroupArray;
  }
}
